var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _ellipse, _ellipse2, _path60, _path61, _path62, _path63;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 579.9 537.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "team building") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55,187.18c6.57-15.68,26.2-10.67,38.38-6.18,11.42,4.22,22.75,9.53,35,10.77,10.66,1.09,20.33-2,30-6.19,11.29-4.84,22.93-10.84,35.55-8.15.94.2,1.35-1.24.4-1.44-11.16-2.38-21.56,1.7-31.66,6.1-6.36,2.77-12.73,5.72-19.52,7.3a49,49,0,0,1-23.16-.64c-17.32-4.29-55.41-28.25-66.42-2-.38.89,1.08,1.28,1.44.4Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.39,469.86c20.88-26.25,61.84-22.94,91.33-18.78,32.27,4.55,64.35,10.67,95.79-1.43,16.08-6.19,30.78-15.37,45.32-24.5.81-.51.06-1.81-.76-1.3-13.93,8.75-28,17.58-43.32,23.71-16.28,6.51-33.28,8.75-50.75,7.83-32.51-1.73-64.76-12.22-97.48-7.24-15.33,2.33-31.26,8.17-41.19,20.65-.6.75.45,1.82,1.06,1.06Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,462.32c13.21-9.57,28.6-16.16,45.07-16.74,16-.55,31.46,4.19,46.33,9.53,14.49,5.21,28.81,11.21,43.93,14.4A99.55,99.55,0,0,0,566.63,449c.75-.61-.32-1.67-1.06-1.06C540.72,468.25,508,474.7,477,466.72c-28.47-7.35-55.58-24-85.8-22.61-16.42.76-31.8,7.35-45,16.91-.77.56,0,1.86.76,1.3Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.54,389.62c18.11-7,37.43-3,55.68,1.28s36.61,9,55.34,11.13c31.13,3.62,65.19-.68,88.87-23,.7-.67-.36-1.73-1.06-1.07-25.9,24.45-63.6,26.62-97,21.33-18.12-2.87-35.78-7.76-53.69-11.61-16-3.45-32.83-5.54-48.51.53-.89.34-.5,1.79.4,1.44Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.35,244c27.14-15.42,59.25-10.25,88.38-4.69s57.88,9.85,86.64.07a119.92,119.92,0,0,0,38.66-22c.74-.62-.32-1.68-1.06-1.06a117.87,117.87,0,0,1-50.07,25C380,245.78,360,244,340.16,240.46c-33.94-6-71.49-16-103.56,2.21a.75.75,0,0,0,.75,1.3Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.09,199.4c8.65,5.25,18.84,3.66,28.22,1.46,11.6-2.72,22.82-6.8,34-11,22.44-8.44,45.19-17.57,69.58-17a.75.75,0,0,0,0-1.5c-22.18-.56-43.12,6.87-63.59,14.59-10.36,3.91-20.71,7.9-31.35,11-11.26,3.3-25.22,7.65-36.06,1.07-.83-.5-1.58.8-.76,1.3Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.09,73.92c37.63,9.66,71.38-14.53,105.36-26.23,38.83-13.37,78.75-4.1,116,9.87.91.34,1.3-1.11.4-1.45-34.89-13.08-73.14-22.74-110-12-36.47,10.59-71.51,38.63-111.37,28.39a.75.75,0,0,0-.4,1.45Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.33,147.12a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#461eb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.18,347.73c.95-2.39,2.84-3.21,5.65-2.47.61.48,1.23.93,1.86,1.38a4.36,4.36,0,0,0,2.4.72c1.94-.13,2.51-1.69,3.9-2.7,3.6-2.63,4,.73,7,1.4,2,.46,7-4.15,8.09-1.73.4.87,1.69.11,1.29-.76-1-2.19-3.25-1.9-5.14-.94s-2.94,2.27-5.31,1c-.67-.37-1.06-1.31-1.77-1.68a3.18,3.18,0,0,0-2.52-.42c-1.45.34-1.94,1.71-3,2.48-3.62,2.51-4.13.46-7.07-.63-3.13-1.16-5.09,1.17-6.65,3.62-.52.82.78,1.57,1.3.76Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#461eb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.25,354.32c2.81-5.85,6.85.14,10.62-1.21.77-.27,1-.94,1.56-1.26,2.52-1.38,4.56.07,6.63,1.22,2.43,1.35,5.87,2.76,6.9-1.07a.75.75,0,0,0-1.44-.4c-1.09,4-7-2.3-9-2.62-2.42-.39-3.32,1.33-5.49,1.74-2.4.46-4-1.29-6.58-.82a6,6,0,0,0-4.49,3.66c-.42.86.87,1.63,1.29.76Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#461eb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,215.28c.84-6.41,7,.12,9.49-.8,2.93-1.07,2-5.75,6.38-3.32,1.32.73,2,2.17,3.75,1.57.5-.17.81-.75,1.22-1a10,10,0,0,0,.56-1.14c2.88-2.17,4.89-1.86,6,.9.54.8,1.84,0,1.3-.75-2.08-3.05-4.07-4.6-7.52-2.94-.45.22-.48,1.12-.84,1.33l-3.43,1a11.54,11.54,0,0,0-1.47-1.32c-1-.3-1.22-.88-2.39-.63-1.38.29-1.54,1.39-2.33,2.27A1.79,1.79,0,0,1,51.6,212q-1.49,1.35-2.58-.18c-.94-.35-1.3-1-2.31-1.11-3-.44-5.05,1.91-5.4,4.59-.12.95,1.38.95,1.5,0Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#461eb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,222c1.24-3.85,5.65,1.34,7.65,1s1.94-2.29,3.31-3.13c3.77-2.31,4.49,2.17,7.55,2.65,2.12.33,4.13-1.17,5.7-2.33.77-.57,0-1.87-.76-1.3a8.49,8.49,0,0,1-7.08.52c-.55-.31-.89-1.23-1.42-1.62a3,3,0,0,0-3.61-.48c-1.82.91-1.06,1.7-3.74,2.15-3.15.54-7.37-3.13-9,2.1-.29.92,1.15,1.32,1.45.4Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#461eb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.42,554.77c3.71-4.27,9.13,4.1,13.57,3.17,1.49-.31,1.76-1,2.84-1.85,2.86-2.32,4.41-1.89,7.53-.2,2,1.08,4.07,2.17,6.28,1,.74-.38,1.23-1.44,1.91-1.76,1.87-.9,2.9.17,4.4.69,1.21.41,1.51.79,2.87.54,1-.18.55-1.63-.4-1.45-2.07.39-3.4-2.37-5.48-2.2-1.38.11-1.4.8-2.45,1.36-2.08,1.1-3.08,2-5.42,1-1-.4-1.9-1.14-2.87-1.61a7.12,7.12,0,0,0-3.64-1,4.43,4.43,0,0,0-2.72,1.27c-2.23,1.92-1,3.83-6.55,1.79a21.21,21.21,0,0,1-3-2c-2.6-1.55-5.72-2.37-7.91.14-.63.73.42,1.8,1.06,1.06Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#461eb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.55,564.13c3.69-4.52,5.82,1.27,8.92,1.51,2.16.17,3.9-2.28,6.07-2.15,3.36.2,5.63,3.57,9,1.38.8-.52.05-1.82-.76-1.29-2.8,1.82-6-1.57-8.82-1.69-2.1-.09-3.13,1.37-5.18,1.36-3.67,0-7-4.22-10.29-.18-.6.75.45,1.81,1.06,1.06Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#461eb8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.96,
    cy: 120.56,
    r: 10.44,
    style: {
      fill: "none",
      stroke: "#461eb8",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.14,
    cy: 382.81,
    r: 4,
    style: {
      fill: "none",
      stroke: "#461eb8",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.72,
    cy: 463.37,
    r: 6.71,
    style: {
      fill: "none",
      stroke: "#461eb8",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.15,
    cy: 5.2,
    r: 4.7,
    style: {
      fill: "none",
      stroke: "#461eb8",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 576.88,
    cy: 120.3,
    r: 2.52,
    style: {
      fill: "none",
      stroke: "#461eb8",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.25,
    cy: 114.76,
    r: 6.43,
    style: {
      fill: "#ec615b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.63,
    cy: 29.6,
    r: 4.81,
    style: {
      fill: "#ec615b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.84,
    cy: 472.27,
    r: 8.9,
    style: {
      fill: "#ec615b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.7,
    cy: 328.99,
    r: 4.23,
    style: {
      fill: "#ec615b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.17,
    cy: 495.43,
    r: 7.4,
    style: {
      fill: "none",
      stroke: "#ec615b",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.74,487a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#ec615b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.5,429.7c-.4-1.73,7.07.32,8.16,0,1.78-.53,2.55-1.92,4.55-2.4,2.84-.67,5.77.35,8.46,1.12a9.66,9.66,0,0,0,5.7.31c3-.56,4.74-.86,7.65,0a10,10,0,0,0,4.08.56c1-.07,1-1.57,0-1.5-3.84.28-6.71-2.32-10.57-1.52-2.38.5-4,1.18-6.46.68-1-.2-2-.61-3-.84a15.16,15.16,0,0,0-5.57-.38c-2.57.41-4,2.11-6.61,1.87-1.63-.14-3.32-1.1-5-1-2.07.14-3.34,1.5-2.89,3.45.21.94,1.66.54,1.45-.4Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#ec615b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.82,436.38c3.85-1.56,6.79.5,9.73,2.58a.77.77,0,0,0,1-.27c2.15-2.81,4.91-3.23,8-2.22.75.25,1.38.74,2.14,1a9.93,9.93,0,0,0,5.38,0c.94-.21.55-1.66-.4-1.45-5.58,1.25-8.93-5-13.85-.94-2.9,2.38-2.23,1.36-5.9-.08a7.75,7.75,0,0,0-6.49-.08c-.88.36-.49,1.81.4,1.44Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#ec615b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.83,102.09a71.66,71.66,0,0,0-.35,12.79c.41,6.79,1.06,17.29,7.92,26.84a37.89,37.89,0,0,0,6,6.59,56.69,56.69,0,0,0,15.81,2.32c11.91,0,20.73-3.82,29-7.52a104.62,104.62,0,0,0,22.67-13.89,44.71,44.71,0,0,0-1.37-7.9c-4.93-18.54-20.49-29-27.54-33.16a50.63,50.63,0,0,1-10.18,9.57c-3.85,2.73-11.79,8.35-23.15,8.73A38.27,38.27,0,0,1,63.83,102.09Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.24,89a62,62,0,0,1,7.9,8,49.15,49.15,0,0,1,9.56,16.25,43.36,43.36,0,0,1,1.5,20.6,69.88,69.88,0,0,1,52,35.38,113.28,113.28,0,0,0,6.11-13.1c8.9-22.8,8.65-44.19,6.85-58.83a81.3,81.3,0,0,0-28.47-13.67C253.61,77,231.85,85.58,224.24,89Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.48,508.56c1,2.45,2.56,5.82,4.57,9.74,2.81,5.49,7.12,13.89,13.39,21.55C304.72,553.6,318.31,560,324,562.63a92.06,92.06,0,0,0,23.23,7.12,111.94,111.94,0,0,0,16.51-12.41A114.42,114.42,0,0,0,389,524a38.29,38.29,0,0,1-12.51-2.73c-8.9-3.61-13.94-9.67-17.57-14.13-10.26-12.62-13.9-26.66-15.34-35a84.39,84.39,0,0,0-68.12,36.46Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.31,472A40.93,40.93,0,0,0,321,489.53c-4.69,8.89-6.19,19.89-3.41,28.51,5.54,17.13,29.5,29.44,57.46,24.26a70.12,70.12,0,0,1-27.8,27.45A94.94,94.94,0,0,1,329,564.64a92.56,92.56,0,0,1-31.38-20.25,86.1,86.1,0,0,1-21.36-37,87.52,87.52,0,0,1,32.27-27.09A86.61,86.61,0,0,1,339.31,472Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#9e9e9e",
      opacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.64,89.44a56.52,56.52,0,0,0-8.21,15.8c-6.34,19.21-.28,36.34,2.22,42.4a51,51,0,0,1-32.21.67,50.12,50.12,0,0,1-12.15-46.86A32.21,32.21,0,0,0,78.89,107C99.3,110.07,114.62,90.76,115.64,89.44Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#9e9e9e",
      opacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.65,90.24A49.37,49.37,0,0,1,238.56,106a50.63,50.63,0,0,1,5,15.61,56.37,56.37,0,0,1,.51,14.37,111.79,111.79,0,0,1,16,4.27c9.21,3.21,17.22,6,24.47,13a45.65,45.65,0,0,1,10.66,16.05,134.12,134.12,0,0,0-7-28.76,139.92,139.92,0,0,0-38.5-56.06Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#9e9e9e",
      opacity: 0.14
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.08,102.09a67,67,0,0,0,12,46.77c.56.78,1.86,0,1.3-.75a65.75,65.75,0,0,1-11.77-46c.11-1-1.39-1-1.5,0Z",
    transform: "translate(-8.86 -32.82)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.76,102c6.91,6.15,17.09,5.62,25.58,3.6A50.48,50.48,0,0,0,116.17,90c.64-.72-.42-1.78-1.06-1.06A49.25,49.25,0,0,1,93,103.29c-8.54,2.64-20,4-27.19-2.37-.72-.64-1.78.41-1.06,1.06Z",
    transform: "translate(-8.86 -32.82)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.24,149c21.7,8,48.33-4.34,65.75-17,.78-.56,0-1.87-.75-1.3C125.1,143.18,99,155.4,77.64,147.58c-.91-.33-1.3,1.12-.4,1.45Z",
    transform: "translate(-8.86 -32.82)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.6,88.81a50.55,50.55,0,0,1,28.54,40.41c.09,1,1.59,1,1.5,0a52.08,52.08,0,0,0-29.28-41.7c-.87-.42-1.63.87-.76,1.29Z",
    transform: "translate(-8.86 -32.82)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M277.83,507.4c4.89-11.21,18.12-19.27,28.39-25,11.48-6.44,24.14-10.34,37.38-9.51,1,.06,1-1.44,0-1.5-13.48-.85-26.45,3.16-38.13,9.72-10.43,5.85-24,14.19-28.93,25.57-.39.88.91,1.64,1.29.76Z",
    transform: "translate(-8.86 -32.82)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M343.88,473.43c3.21,22.67,19.41,50.69,45.14,51.28a.75.75,0,0,0,0-1.5C364,522.63,348.44,495,345.33,473c-.14-.95-1.58-.55-1.45.4Z",
    transform: "translate(-8.86 -32.82)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M276.55,510.83c9.74,31.29,38,54.84,70.51,58.86.95.12.94-1.38,0-1.5C315.23,564.25,287.52,541,278,510.43c-.29-.92-1.74-.53-1.45.4Z",
    transform: "translate(-8.86 -32.82)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M347.64,570.4a112.2,112.2,0,0,0,40.21-43.21c.45-.86-.84-1.62-1.29-.76a110.76,110.76,0,0,1-39.68,42.67c-.81.51-.06,1.81.76,1.3Z",
    transform: "translate(-8.86 -32.82)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.38,92.9a42.83,42.83,0,0,1,16.1,40.8c-.16.94,1.29,1.35,1.44.4a44.4,44.4,0,0,0-16.78-42.49c-.77-.59-1.52.71-.76,1.29Z",
    transform: "translate(-8.86 -32.82)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M232.1,88.34c26-5.81,56.22-7.2,76.71,12.91.69.68,1.75-.38,1.06-1.06C289,79.7,258.26,81,231.7,86.89c-.94.21-.54,1.66.4,1.45Z",
    transform: "translate(-8.86 -32.82)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.32,137.75c18.9,4.26,40.25,11.6,47.13,31.73a.76.76,0,0,0,1.37.18c12.21-21.07,12.76-45.84,12.93-69.53a.75.75,0,0,0-1.5,0c-.17,23.43-.65,47.94-12.73,68.77l1.37.18c-7.06-20.68-28.7-28.39-48.17-32.78-.94-.21-1.34,1.24-.4,1.45Z",
    transform: "translate(-8.86 -32.82)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320.27,527.12a65.22,65.22,0,0,0,13.27-10.6c.67-.7-.39-1.76-1.06-1.06a63.84,63.84,0,0,1-13,10.37c-.83.5-.07,1.8.75,1.29Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#ec615b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.92,517a45,45,0,0,0,9.46,12.22c.71.65,1.78-.41,1.06-1.06a44,44,0,0,1-9.23-11.91c-.45-.86-1.74-.1-1.29.75Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#ec615b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.27,113.24a25.51,25.51,0,0,1,17.39,8.68c.64.72,1.7-.34,1.06-1.06a27.07,27.07,0,0,0-18.45-9.12c-1-.08-.95,1.42,0,1.5Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#ec615b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,105.32l-2,15.28c-.13,1,1.38.94,1.5,0l2-15.28c.12-.95-1.38-.94-1.5,0Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#ec615b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.35,126.33a114.32,114.32,0,0,0,15.33-7.28.75.75,0,0,0-.76-1.3,110.77,110.77,0,0,1-15,7.13c-.89.35-.51,1.8.39,1.45Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#ec615b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.79,114.16l9.85,14.47c.54.79,1.84,0,1.3-.76l-9.86-14.47c-.54-.79-1.84,0-1.29.76Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#ec615b"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "guy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.23,310.1a233.45,233.45,0,0,0-24.31,43.46A239.25,239.25,0,0,0,105.23,454a68.37,68.37,0,0,0,28,21c30,11.89,57.78-3.11,62-5.48A289,289,0,0,1,200,438.65c8.15-39.19,19.35-52.06,20.22-77.61.36-10.72-1-26.47-9.84-46Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#461eb8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.52,249.71a29,29,0,0,1-1.32-9.66A30.44,30.44,0,0,1,152.33,226c6.91-11.65,19.87-14.22,21.63-14.54A33.81,33.81,0,0,1,198.74,217a41.57,41.57,0,0,1,13.7-4.94c5.05-.85,9.53-1.6,12.22,1,3.06,3,2,8.5,1.64,10.25-.7,3.54-2.57,7.88-10.83,15.42-7,6.43-13.53,12.35-24.46,16.08-4.39,1.5-10.3,2-22.11,3.12-4.53.41-8.13.6-12-1.28A18.11,18.11,0,0,1,149.52,249.71Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#ec615b"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.35,255.34a28,28,0,0,1,4.77,7.09c2.12,4.58,1.89,7.75,2.63,13.25A96.94,96.94,0,0,0,192,297.6c2.14,5.52,3.26,8.33,6,10.86,5.59,5.09,12.89,5.16,15.23,5.19,3.27,0,7.61.07,11.51-2.81,3.61-2.68,4.8-6.37,6.25-10.87s2.89-9,1.23-14.58A20.27,20.27,0,0,0,225,275.26a22.32,22.32,0,0,0-11.5-4.53q-7.19-4.44-14.62-9.45-4.5-3-8.77-6.07Z",
    transform: "translate(-8.86 -32.82)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.54,253.6c.21,1.58.51,3.91.8,6.72.86,8.23,2.19,20.89,1.14,35.27a143.82,143.82,0,0,1-6.08,31.92,41.7,41.7,0,0,0,49.8-8.94L196,305.45A48.92,48.92,0,0,1,192,297.6c-3.7-9.44-2.6-15.33-4.67-24.81a63.37,63.37,0,0,0-5.75-15.73,49.21,49.21,0,0,1-30.08-3.46Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.24,254.47a42.61,42.61,0,0,0,2.72,7.62c2.15,4.61,3.57,7.65,6.66,9.43,4.58,2.65,10,.89,11.68.27h3.77q-1-4-2.35-8.17a164.87,164.87,0,0,0-6.63-17.54Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.46,259.82a77.61,77.61,0,0,0-6,14c-3.29,10.5-2.88,17.21-3.9,23.18-1.28,7.5-5.51,18-19.25,29.72a171.59,171.59,0,0,0,4.14-21.17,173.54,173.54,0,0,0,1.42-19.48,175.41,175.41,0,0,0-.78-19.69Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#9e9e9e",
      opacity: 0.17
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5,254.84c.31,2,.75,4.85,1.21,8.33,2.8,21.38,1.54,29,3.9,29.84s8.28-5.32,23.54-35.68a64.14,64.14,0,0,1-28.65-2.49Z",
    transform: "translate(-8.86 -32.82)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M207.54,250.22A121,121,0,0,1,215.35,272l.92-.93a25,25,0,0,0-4.82-.38.75.75,0,0,0,0,1.5,15.63,15.63,0,0,1,4.42.33.76.76,0,0,0,.92-.92,122.83,122.83,0,0,0-7.95-22.12c-.41-.88-1.71-.12-1.3.75Z",
    transform: "translate(-8.86 -32.82)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190.29,255c2.17,5.37,3.89,12.67,8.73,16.34a13,13,0,0,0,13.66,1.09c.87-.42.11-1.72-.75-1.3a11.28,11.28,0,0,1-14.11-3.21c-2.91-3.81-4.3-8.91-6.08-13.32-.36-.88-1.81-.5-1.45.4Z",
    transform: "translate(-8.86 -32.82)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M217.1,272.36c17.23,4.34,19.49,25.07,8.53,36.91-.66.7.4,1.77,1.06,1.06,11.72-12.66,9.13-34.8-9.19-39.42a.75.75,0,0,0-.4,1.45Z",
    transform: "translate(-8.86 -32.82)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M181.74,259.63c9.47,16.13,3,39.46,18.91,52.18.74.6,1.81-.45,1.06-1.06-15.63-12.53-9.29-35.9-18.68-51.88a.75.75,0,0,0-1.29.76Z",
    transform: "translate(-8.86 -32.82)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M150.78,255a173.39,173.39,0,0,1-3.18,71.52.75.75,0,0,0,1.45.4,175.14,175.14,0,0,0,3.17-72.31c-.16-.95-1.6-.55-1.44.39Z",
    transform: "translate(-8.86 -32.82)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.86,249.37c2.21,6,8.22,8.16,14.1,9a62.65,62.65,0,0,0,25.94-2,64.27,64.27,0,0,0,38.17-30.95c.47-.84-.82-1.6-1.29-.75a61.94,61.94,0,0,1-54,32.74c-7.24.08-18.44-.32-21.44-8.41-.33-.89-1.78-.51-1.44.4Z",
    transform: "translate(-8.86 -32.82)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150.24,249.51a29.31,29.31,0,0,1,19.14-36.11c14.62-4.87,30,1.61,38.7,13.83.56.78,1.86,0,1.3-.76-9.42-13.22-26.24-20-41.84-14a30.78,30.78,0,0,0-18.75,37.44c.28.92,1.73.53,1.45-.4Z",
    transform: "translate(-8.86 -32.82)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M201.25,217.38a38.42,38.42,0,0,1,12.64-4.87c2.89-.54,7.51-1.39,10,.83,3.41,3,2.48,8.46.64,11.92-.46.85.83,1.61,1.29.75,2.53-4.73,2.92-13.09-3.34-15.26-6.67-2.31-16.39,2-22,5.34a.75.75,0,0,0,.76,1.29Z",
    transform: "translate(-8.86 -32.82)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M201,253.58a9.28,9.28,0,0,1,1.38,3.88l1.4-.38a10.56,10.56,0,0,1-1.95-4.64c-.16-1-1.6-.55-1.45.39a11.6,11.6,0,0,0,2.1,5c.38.52,1.5.45,1.4-.38a11.24,11.24,0,0,0-1.58-4.64c-.51-.82-1.81-.07-1.3.76Z",
    transform: "translate(-8.86 -32.82)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M182.64,264.37c-4.39-1.32-7.72,3.52-7.84,7.45a7.35,7.35,0,0,0,8.06,7.66c.95-.11,1-1.61,0-1.5-9.39,1-7.34-14.19-.62-12.17a.75.75,0,0,0,.4-1.44Z",
    transform: "translate(-8.86 -32.82)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56,311.65c7.13,3.18,20.48,5.06,26.44-1.63.64-.72-.42-1.78-1.07-1.06-5.46,6.14-18.14,4.28-24.61,1.4-.87-.39-1.64.9-.76,1.29Z",
    transform: "translate(-8.86 -32.82)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M201.72,259.71a3.63,3.63,0,0,1,3.62-1.33c.94.2,1.34-1.24.4-1.45a5.11,5.11,0,0,0-5.08,1.72c-.6.74.45,1.81,1.06,1.06Z",
    transform: "translate(-8.86 -32.82)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M195.25,305.25a36.82,36.82,0,0,0-.29,7.42c.06,1,1.56,1,1.5,0a35,35,0,0,1,.23-7c.13-.94-1.31-1.35-1.44-.4Z",
    transform: "translate(-8.86 -32.82)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hand"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.53,324.09a29,29,0,0,1,10.29-7.31c6.61-2.74,13.07-2.36,20.47-.87,13.87,2.8,23.4,8,30.89,11.69a279.8,279.8,0,0,0,37.24,15.2c7.87-4.14,16.22-8.94,24.86-14.52,6.77-4.37,13-8.77,18.75-13.09a21.76,21.76,0,0,1,20.16-18,59.18,59.18,0,0,0,27.12,6.92c-1,5.23-1.42,8.73-.82,8.9s1.8-1.75,1.41-2.43c-.83-1.47-10.26,1.73-34.43,13.14-9.8,10.55-18.38,19.18-25,25.66-12.09,11.8-18.12,17.35-26,23-4.85,3.49-9.09,6.13-12.1,7.92a58.15,58.15,0,0,1-8.11.54,62.51,62.51,0,0,1-23.34-4.85c-9.29-3.58-22.78-7.72-43.44-12.84Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,320.92c3.28,2.73,8.35,6.88,14.67,11.74,35.16,27.06,53.37,40.72,71,37.48,4.08-.75,11.74-7.35,27.05-20.54,29-25,37-36.51,55.07-41.39a62.42,62.42,0,0,1,23.05-1.64c1.37,3.18,1,5.05.48,6.12-2.79,6-15.89,1.51-28.85,8.07C352,322,350.83,323,341.78,331.91,325,348.34,320.11,353.71,314.47,359a174.49,174.49,0,0,1-28.25,21.49c-7-.39-14.39-1.13-22.18-2.34a229.57,229.57,0,0,1-54.75-15.69Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#9e9e9e",
      opacity: 0.24
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M198.63,320.65c14.05-10.43,31.31-2.62,45.49,3.21l46.23,19c.89.36,1.28-1.09.4-1.45-17.21-7.08-34.4-14.23-51.65-21.23-13.12-5.33-28.68-10.15-41.23-.83-.76.57,0,1.87.76,1.29Z",
    transform: "translate(-8.86 -32.82)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M287,346.92c12.94-7.8,26.22-15.06,39.15-22.87,4.34-2.62,8.65-5.64,11.58-9.86,1.55-2.22,2.36-4.73,3.53-7.14a14.94,14.94,0,0,1,9.8-8.33.75.75,0,0,0-.39-1.44,16.27,16.27,0,0,0-10.42,8.34c-1.82,3.54-2.81,6.94-5.53,9.95a37.27,37.27,0,0,1-8,6.39c-13.21,8.3-27.08,15.61-40.45,23.66a.75.75,0,0,0,.76,1.3Z",
    transform: "translate(-8.86 -32.82)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M209.1,363.19a441.75,441.75,0,0,0,43.34,13.05q10.53,2.6,21.19,4.64c5.18,1,10.32,1.82,15.18-.73,5.36-2.82,10.24-7.14,14.91-10.95,5.53-4.52,10.86-9.28,16-14.19,10.38-9.85,20.15-20.32,29.92-30.78.65-.71-.41-1.77-1.07-1.06-17.88,19.16-36,39.13-57.8,54-6.93,4.71-13.74,2.94-21.4,1.38q-10.17-2.08-20.23-4.64c-13.41-3.41-26.64-7.49-39.68-12.14-.91-.32-1.3,1.12-.39,1.45Z",
    transform: "translate(-8.86 -32.82)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M361,299.74a46.31,46.31,0,0,0,12.09,3.95,44.46,44.46,0,0,0,4.88.57c2.49.15,2.83-.47,4.3,2.08,1.36,2.38,1.15,3.59.39,6.15a.75.75,0,0,0,1.44.4c.89-3,2-8.44-1.58-10a11.19,11.19,0,0,0-3-.1,47.28,47.28,0,0,1-6.05-.58,45.42,45.42,0,0,1-11.74-3.8c-.87-.41-1.63.88-.75,1.29Z",
    transform: "translate(-8.86 -32.82)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M350.11,324.13c4.29-6,16.67-1.73,22.87-2.64,5.18-.76,8-3.44,10.16-8.06.41-.87-.88-1.63-1.29-.75-4.31,9.16-12.7,7.38-21.23,7-4.26-.17-9.12-.12-11.8,3.66-.56.79.74,1.54,1.29.75Z",
    transform: "translate(-8.86 -32.82)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "window"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78,225.34c.61,1.58,29.29,208.47,29.29,208.47L220,537q-6.81-108.94-13.61-217.9Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,264.06a184.8,184.8,0,0,0-7.87,44.48C76.83,430.76,196.91,520.36,220,537l-181-103.2Q24.43,329.58,9.78,225.34Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#9e9e9e",
      opacity: 0.18
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "girl"
  }, /*#__PURE__*/React.createElement("g", {
    id: "window-2",
    "data-name": "window"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.75,57.62c3.53,11.62,6.75,23.86,9.52,36.69,14.62,67.75,11.89,129.15,4.07,178l187.55,14.94,5.43-218.79Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.6,171.46a153.65,153.65,0,0,1,1.76-35.37c3.24-19.38,5.09-30.48,14.44-38.16,11.53-9.47,31-10.91,44.86-1.87,16,10.47,12.09,37.14,11.22,57.95-1.34,31.73,1.47,76.53,20,133.27L505,278c-.6-2.08-1.22-4.15-1.87-6.23A440.64,440.64,0,0,0,457.6,171.46Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#9e9e9e",
      opacity: 0.18
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_right",
    "data-name": "hand right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.06,176c-.86,1.09-2.08,2.68-3.44,4.67-1,1.42-5.26,7.7-7.31,13.22-2.11,5.68-1.92,10.77-1.28,17.58a291.88,291.88,0,0,0,6,37.13,184.85,184.85,0,0,0-14.71,12.64c-5.54,5.28-6.12,6.48-11.52,11.33-6.86,6.15-10.28,9.23-15.76,12.05-3.79,1.95-5.81,2.39-10.07,5.19-6.05,4-7.52,6.74-8.14,8.23-1.35,3.3-1.47,7.62,0,8.33s4.83-2.61,6.8-4.64a29.63,29.63,0,0,0,2.92-3.48A20.93,20.93,0,0,0,373,302.92a20.63,20.63,0,0,0,9.62-2.06,26.32,26.32,0,0,1,2.82-7c3.13-5.4,7.18-7.89,14.81-13,10.06-6.68,15.07-10.35,16.26-11.22,8.75-6.43,11.58-9.32,13.63-13.4,1.58-3.12,2.09-5.75,2.79-9.39a74.39,74.39,0,0,0,.67-19.14C432.54,217.11,427.37,198.37,417.06,176Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.83,319.13a30.24,30.24,0,0,0,3.28-4.72c2.35-3.84,2.41-5.09,4.56-7.88,1.12-1.44,2.58-3.33,3.42-3,1.12.42.54,4.45.35,5.69.84-3.38,4.29-4.88,6.5-3.89,1.87.84,3,3.57,2.1,6.24,2.23-1,2.95-.52,3.19-.31,1.18,1.06-.46,4.66-1.53,6.44a13,13,0,0,1-3.94,4.31c-1.77,1.18-3.49,1.61-13.91,1.72-5.09.05-7,0-7.25-.83S355.77,321.47,357.83,319.13Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.27,188c.3,4.15.71,10.31,1.09,17.78.71,13.88,1.07,20.82.73,24.12-.48,4.71-2.77,21.14-14.66,33.68-7,7.39-11.17,6.91-22.12,18A98.36,98.36,0,0,0,376.84,294a97,97,0,0,0-5.55,8.79,8.33,8.33,0,0,0,5.35,1.44,8.69,8.69,0,0,0,6-3.36,31.37,31.37,0,0,1,5.48-10.57c3.27-4.11,6.24-5.61,14.66-11.11,7.51-4.92,11.27-7.39,14.76-10.24,5.91-4.86,10.8-8.87,13.74-15.25,2.86-6.23,2.68-12.16,2.07-18.4C431.64,217.81,426.88,201,422.27,188Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#9e9e9e",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.75,323.7a17.34,17.34,0,0,0,6.33-2.85c7.45-5.45,7.89-15.71,9.86-15.54.66.06,1.45,1.29,2.1,6.24,1.69-.68,2.75-.78,3.19-.31q1.42,1.53-5.73,11Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#9e9e9e",
      opacity: 0.22
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M413.09,180.1c-17.77,19-4.13,46.42-2.77,68.46.06,1,1.56,1,1.5,0-1.33-21.56-15-48.83,2.33-67.4.66-.7-.4-1.77-1.06-1.06Z",
    transform: "translate(-8.86 -32.82)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M412.91,248.53c-8.77,1.8-16.51,11.5-22.55,17.53-8.13,8.11-16.22,15.25-26.6,20.35-6.74,3.31-15.2,8.54-14.32,17.32,1,10.23,9.4-2.25,11.69-5,.62-.74-.44-1.8-1.06-1.06-1.35,1.61-6.46,9.93-8.93,7.12-1.73-2,.91-7.17,2-8.83a18.49,18.49,0,0,1,5.14-4.87c6.17-4.14,13.14-6.52,19.09-11.11,5.67-4.37,10.66-9.52,15.72-14.56,5.4-5.37,12.5-13.88,20.2-15.45.95-.2.55-1.64-.4-1.45Z",
    transform: "translate(-8.86 -32.82)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M432.37,234.51c.39,8.26.5,17.07-4.53,24.1-4.63,6.46-12,10.65-18.44,15.09-10.51,7.25-24,13.63-27.49,27a.75.75,0,0,0,1.45.4c2.37-9.18,9.19-13.92,16.61-19,6.76-4.67,13.7-9.16,20.28-14.09,4.65-3.48,9-7.48,11.33-12.89,2.81-6.44,2.61-13.67,2.29-20.53,0-1-1.55-1-1.5,0Z",
    transform: "translate(-8.86 -32.82)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M354.86,322.59a20.63,20.63,0,0,0,6.27-6.74c1.41-2.28,4.81-11.26,7.77-11.43,1-.05,1-1.55,0-1.5-2.74.16-4.7,4.36-5.85,6.4-2.51,4.41-4.55,9.1-8.94,12-.81.53-.06,1.82.75,1.29Z",
    transform: "translate(-8.86 -32.82)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M368.45,303.89c1.24,2-1.28,6.87-2.05,8.57a46.75,46.75,0,0,1-3.26,6c-.52.82.78,1.57,1.3.76a48.1,48.1,0,0,0,4.53-9.08c.78-2.14,2.13-4.85.77-7-.51-.82-1.81-.07-1.29.75Z",
    transform: "translate(-8.86 -32.82)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M369.15,310.69a20.51,20.51,0,0,1,7.87-5.82l-1-.27c2.52,4.37-1.53,10.78-4.07,14.45-.55.79.75,1.54,1.3.75,2.88-4.15,6.95-11,4.07-16a.78.78,0,0,0-1-.27,21.29,21.29,0,0,0-8.17,6.06c-.62.73.43,1.8,1.06,1.06Z",
    transform: "translate(-8.86 -32.82)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M375.22,305.11A69.18,69.18,0,0,1,368,319.5c-.54.8.76,1.56,1.29.75a70.72,70.72,0,0,0,7.42-14.74c.33-.91-1.11-1.3-1.44-.4Z",
    transform: "translate(-8.86 -32.82)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M378.57,312.08c2-.08,2.64-.42,1.94-1-.12.5-.26,1-.4,1.47a25.4,25.4,0,0,1-1.31,3.36,27.07,27.07,0,0,1-3.57,5.59c-.61.74.45,1.8,1.06,1.06,2.42-2.95,5.26-7.15,5.67-11.08.3-2.85-3.18-1.48-4.45-.42-.75.62.32,1.68,1.06,1.06Z",
    transform: "translate(-8.86 -32.82)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M354.4,323.6c6.34,2.39,14.62.27,21.1-.59.94-.12,1-1.63,0-1.5-6.34.84-14.53,3-20.7.64-.91-.34-1.3,1.11-.4,1.45Z",
    transform: "translate(-8.86 -32.82)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "torso-2",
    "data-name": "torso"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.23,177.67c1.47,4.05,3.75,10.62,6,18.89,5.19,18.84,3.92,23,8.95,30.89,4.4,6.9,6,4.69,17.42,17.46,7.16,8,11,12.52,13.72,19a47.37,47.37,0,0,1,3.12,11.59l60.84,6.33A288.65,288.65,0,0,0,488,201.92a285,285,0,0,0-23.4-34.47c-7.6-2.07-26.6-6-45.12,3.4A54.25,54.25,0,0,0,409.23,177.67Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#ec615b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_left",
    "data-name": "hand left"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.05,178.39a26.51,26.51,0,0,1,4.36-5.38c2.4-2.27,5.75-5.43,10.73-5.95,5.79-.6,10.21,2.75,11.76,3.92,3.17,2.41,4.76,5.14,6.78,8.83,7,12.86,9.15,18.31,9.15,18.31,4.43,11.26,6.65,16.9,10,27.66,2.91,9.35,6.35,21.53,9.57,36.08a16.92,16.92,0,0,1-4.09,6.64,17.74,17.74,0,0,1-8.09,4.36c-26.2,7-60.28,6.09-60.28,6.09-3.7-.1-9-.27-15.5-.6a15.12,15.12,0,0,1-6.33.44c-3.6-.54-4.87-2.17-8.62-3.78a28.1,28.1,0,0,0-11.2-2.2c-5.94.15-10.68,2.57-11.75.91a2.29,2.29,0,0,1-.29-1.33,3.36,3.36,0,0,1,1.75-2.34,11.4,11.4,0,0,1,1.07-1.53,11.12,11.12,0,0,1,1.53-1.54,10.87,10.87,0,0,1,.59-2,11.46,11.46,0,0,1,2.13-3.31c1.93-1.95,5.3-1.73,9.32-1.42a41.38,41.38,0,0,1,9.09,1.77c.17-1.9.64-3,1.42-3.3q2.63-1,9.92,10A115.41,115.41,0,0,0,447.7,266a126.11,126.11,0,0,0,17.95-5.79c6.54-2.67,8.41-4.09,14.28-5.9a71.2,71.2,0,0,1,11.22-2.48c-3.08-7.81-5.77-14.32-7.79-19.12-8.49-20.14-15.47-34.6-17.36-38.49C462.77,187.62,460,182.16,458.05,178.39Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.45,166.85A98.75,98.75,0,0,1,486,177.69c14.69,21.57,16.48,42.82,17.65,59.17,1.3,18.12-1.44,22.09-3,23.86-3.5,3.95-6.82,3.4-25.74,6.38-11.62,1.84-32.16,5.49-42.58,5.53a91,91,0,0,1-10.13-.58c-2.53-.32-3.93-.7-5.14-.81a50.54,50.54,0,0,0-17.82,1.56,34.09,34.09,0,0,1,17.17,1.38,32.86,32.86,0,0,1,9.1,4.95l7.73-1.12c12.73.68,23.51.66,31.71.44,20.67-.54,28.5-2.37,32-3.3A97.85,97.85,0,0,0,516,268l4.08-6.65c-.43-1.95-1.11-5-2-8.63a371.48,371.48,0,0,0-16.72-53c-8-19.78-8.08-14.16-12.91-24.59A14.26,14.26,0,0,0,484.7,170,14.77,14.77,0,0,0,477.45,166.85Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#9e9e9e",
      opacity: 0.21
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M457.4,178.77a789.88,789.88,0,0,1,32.77,72.34c.35.89,1.8.5,1.45-.4A795,795,0,0,0,458.7,178c-.45-.86-1.74-.11-1.3.75Z",
    transform: "translate(-8.86 -32.82)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M495.44,252.73c-2.51-2.26-5.65-1.55-8.71-.83-6,1.42-11.57,4-17.24,6.35a135.92,135.92,0,0,1-38.91,9.45c-.95.09-1,1.59,0,1.5a136.77,136.77,0,0,0,31.64-6.62c5.09-1.74,10-3.92,15-5.91,4-1.62,13.43-6.26,17.19-2.88.72.65,1.78-.41,1.06-1.06Z",
    transform: "translate(-8.86 -32.82)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M484.88,171.86c10.37,12.23,16.09,27.64,21.36,42.57a365.3,365.3,0,0,1,12.82,45.78c.2.94,1.65.55,1.45-.4a363.22,363.22,0,0,0-14.11-49.36c-5.12-14-10.71-28.15-20.46-39.65-.62-.73-1.68.33-1.06,1.06Z",
    transform: "translate(-8.86 -32.82)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M433.56,279.28c17.47.59,35.05,1.17,52.45-1,11.08-1.39,29.19-2.73,34.66-14.45.4-.87-.89-1.64-1.3-.76-3.14,6.73-10.34,9.05-17.05,10.72a151.19,151.19,0,0,1-23.74,3.76c-15,1.25-30,.75-45,.24-1,0-1,1.47,0,1.5Z",
    transform: "translate(-8.86 -32.82)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M432.23,277.63c-7,2.6-12.39-3.52-18.81-5.13-6-1.5-12.87,0-18.89.47-1,.08-1,1.58,0,1.5,8.75-.69,16.44-2,24.57,2.12,4.42,2.23,8.58,4.32,13.53,2.49.9-.34.51-1.79-.4-1.45Z",
    transform: "translate(-8.86 -32.82)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M431.31,267.28a17.83,17.83,0,0,0-6.92-7.72c-1-.61-2.48-1.55-3.72-1.08a1.73,1.73,0,0,0-1.05,2.25c.32.9,1.77.51,1.45-.4-.2-.56,1.67,0,1.76.08a13.51,13.51,0,0,1,1.33.77,15.33,15.33,0,0,1,2.47,2A16.67,16.67,0,0,1,430,268c.42.87,1.71.11,1.3-.75Z",
    transform: "translate(-8.86 -32.82)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M429.17,267.44A26.65,26.65,0,0,0,402,260.58c-.92.29-.52,1.74.4,1.45a25.1,25.1,0,0,1,25.75,6.47c.68.69,1.74-.37,1.06-1.06Z",
    transform: "translate(-8.86 -32.82)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M394.49,273.39c2.12-3.44,8.75-3,12.26-3.47.95-.11,1-1.61,0-1.5-4.2.51-11,.06-13.55,4.21-.51.83.79,1.58,1.29.76Z",
    transform: "translate(-8.86 -32.82)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M396.45,270.23c3.42-3.06,8.1-3.17,12.45-3.2a.75.75,0,0,0,0-1.5c-4.79,0-9.77.29-13.51,3.64-.72.65.34,1.7,1.06,1.06Z",
    transform: "translate(-8.86 -32.82)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M399.2,267c.94-3.14,7.73-2.8,10.23-2.67,1,.05,1-1.45,0-1.5-3.36-.18-10.43-.37-11.68,3.77-.28.93,1.17,1.32,1.45.4Z",
    transform: "translate(-8.86 -32.82)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M400.54,264a3.07,3.07,0,0,1,3.78-1.79c.92.3,1.32-1.15.4-1.44a4.57,4.57,0,0,0-5.62,2.83c-.34.91,1.11,1.3,1.44.4Z",
    transform: "translate(-8.86 -32.82)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M464.91,171.6c3-1.78,6.08-3.67,9.61-3.92,4-.29,6.94,1.74,10,3.95.78.57,1.53-.73.75-1.3-3.08-2.22-6.25-4.33-10.2-4.23s-7.59,2.22-10.92,4.2c-.82.5-.07,1.8.76,1.3Z",
    transform: "translate(-8.86 -32.82)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "head-2",
    "data-name": "head"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.6,126.7a59.56,59.56,0,0,0-.23,16.29,47.68,47.68,0,0,0,6.22,18.7,46.31,46.31,0,0,0,16,15.9,37,37,0,0,0,5.25-.94,38.37,38.37,0,0,0,10.49-4.41,33.62,33.62,0,0,0,5.69,3.88,34.25,34.25,0,0,0,14.85,4,61.52,61.52,0,0,0,10.44-18c2.22-6,8.37-22.64.48-37.63-2.88-5.48-6.51-8.58-10.68-12.14-8.35-7.12-19.27-16.44-33-13.83-15.22,2.89-23.56,18.44-25,25.35C387,124.2,386.81,125.29,386.6,126.7Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.57,106.52a41.76,41.76,0,0,1,14.09,43.21c-3.65,15.41-14.1,24.57-18.18,27.79,2.86-.64,5.92-1.45,9.15-2.49,2.76-.88,5.33-1.83,7.68-2.79a34,34,0,0,0,5.69,3.88,33.14,33.14,0,0,0,8.86,3.23A73.82,73.82,0,0,0,454,153c2.91-9.06,5.53-17.25,1.89-25.5-3.73-8.45-11.94-12.2-19.36-15.58A60.91,60.91,0,0,0,411.57,106.52Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#9e9e9e",
      opacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.09,123.89a54.32,54.32,0,0,1,23.48-20,38.51,38.51,0,0,0,2.7,6.2C420,122.38,432,127.8,437.85,130c2.36-2.93,6-4.16,8.92-3.11,3.64,1.31,4.58,5.51,4.83,6.65a11.14,11.14,0,0,1-1.13,7.59c-2.2,3.84-6.86,6-11.88,5.62-1.47,1-8.14,5.77-9.7,14.54-1.61,9,3.15,17.53,9.7,22.09a23.91,23.91,0,0,0,27.47-.54c7.55-5.56,9.1-14,9.42-16,5.9,4.51,13.27,5.22,18.22,2,5.76-3.77,6.84-12,5.21-17.54-2.61-8.93-11.26-8-25.58-22.6-5.24-5.33-7.63-8.14-10.36-12.48-6.5-10.37-5.83-17-16-22.27-19.8-10.26-41.9-.37-44.45.81A57.08,57.08,0,0,0,376.37,120a56.93,56.93,0,0,1,3,20.47c-.6,13.64-6,17.67-5.93,30.17,0,5.23.09,17.35,8.62,24.78,8.75,7.61,25.33,9.36,34.75-.27,8.28-8.47,6.26-20.86,6-22.33l-13.53,4.82a45,45,0,0,1-13.2-11C382.3,149.57,386.27,127.94,387.09,123.89Z",
    transform: "translate(-8.86 -32.82)",
    style: {
      fill: "#461eb8"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M386.34,123.89c-2.51,20.44,2.67,42.39,20.77,54.28.8.53,1.56-.77.75-1.3-17.64-11.58-22.46-33.11-20-53,.12-1-1.38-.94-1.5,0Z",
    transform: "translate(-8.86 -32.82)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M408.57,178.34a35.65,35.65,0,0,0,20.32-9.24c.71-.65-.35-1.71-1.07-1.06a33.89,33.89,0,0,1-19.25,8.8c-.95.11-1,1.61,0,1.5Z",
    transform: "translate(-8.86 -32.82)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M400.38,130.52a135.57,135.57,0,0,0,2.95,25.32.76.76,0,0,0,1.26.33,42.9,42.9,0,0,0,4.19-5.31c.54-.8-.76-1.56-1.29-.76a40.94,40.94,0,0,1-4,5l1.25.33a133.06,133.06,0,0,1-2.9-24.92c0-1-1.53-1-1.5,0Z",
    transform: "translate(-8.86 -32.82)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M404.55,161.94A22,22,0,0,0,421,155.56c.69-.68-.37-1.74-1.06-1.06a20.39,20.39,0,0,1-15.36,5.94c-1,0-1,1.46,0,1.5Z",
    transform: "translate(-8.86 -32.82)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M391.15,124.53a3.75,3.75,0,0,1,6.22.1c.54.79,1.84,0,1.3-.76a5.24,5.24,0,0,0-8.58-.4c-.58.75.47,1.82,1.06,1.06Z",
    transform: "translate(-8.86 -32.82)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M410,123.69a7.24,7.24,0,0,1,9.51-.47c.75.6,1.82-.46,1.07-1.06a8.78,8.78,0,0,0-11.64.47c-.69.67.37,1.73,1.06,1.06Z",
    transform: "translate(-8.86 -32.82)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M438.38,130.48c2.07-1.92,4.49-3.36,7.38-3,4.19.53,5.18,4.22,5.14,7.7-.07,6.2-3.79,9.53-9.79,9.94-1,.06-1,1.56,0,1.5,8.05-.55,12.53-6.2,11.11-14.27s-10-7.53-14.9-3c-.71.66.36,1.72,1.06,1.07Z",
    transform: "translate(-8.86 -32.82)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 386.77,
    cy: 103.99,
    rx: 1.31,
    ry: 3.78
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.02,
    cy: 103.42,
    rx: 1.31,
    ry: 3.78
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M416.79,144.1h-.14a.75.75,0,0,0,0,1.5h.14a.75.75,0,0,0,0-1.5Z",
    transform: "translate(-8.86 -32.82)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M423.2,141.9a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z",
    transform: "translate(-8.86 -32.82)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M423.34,148a.75.75,0,0,0,0-1.5.75.75,0,0,0,0,1.5Z",
    transform: "translate(-8.86 -32.82)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M423.78,172.77a50,50,0,0,0,13.46,7.55c.9.34,1.29-1.11.39-1.45a47.37,47.37,0,0,1-12.79-7.17c-.75-.58-1.82.47-1.06,1.07Z",
    transform: "translate(-8.86 -32.82)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/Live.7ae0388fae88bf6a2d1b55033ca2d0b0.svg";
export { ForwardRef as ReactComponent };